import { generateExportFilename } from '@warebee/shared/export-converter';
import { useRecoilValue } from 'recoil';
import { brandName } from '../store/global.state';
import { warehouseSelected } from '../store/warehouse.state';

export type ExportFilenameParams = {
  title: string;
};

function useExportFilename(params: ExportFilenameParams) {
  const brandTitleState = useRecoilValue(brandName);
  const warehouse = useRecoilValue(warehouseSelected);

  const filename = generateExportFilename({
    exportTitle: params.title,
    brandTitleState,
    warehouse,
    warehouseId: warehouse.id,
  });
  return filename;
}

export default useExportFilename;
